import { KiCadLegacySymbolParser } from "./legacyParser/KiCadLegacySymbolParser";
import { KiCadModernSymbolParser } from "./modernParser/KiCadModernSymbolParser";
export function KicadSymbolParser(textFileContent) {
    if (KiCadLegacySymbolParser.isLegacySchematicFile(textFileContent)) {
        const parser = new KiCadLegacySymbolParser(textFileContent);
        return parser.parse();
    }
    else if (KiCadModernSymbolParser.isModernSchematic(textFileContent)) {
        const parser = new KiCadModernSymbolParser(textFileContent);
        return parser.parse();
    }
    else {
        throw new Error("Unsupported kicad symbol file");
    }
}
//# sourceMappingURL=KicadSymbolParser.js.map